import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout/index.vue";
import {
  getToken,
  setToken,
  removeToken,
  getStoreId,
  setStoreId,
  removeStoreId,
  setUserInfo,
  getUserInfo,
  removeUserInfo
} from "@/utils/cookies";
import store from "@/store";

Vue.use(Router);

const router = new Router({
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: () =>
        import(/* webpackChunkName: "login" */ "@/views/login/index.vue"),
      meta: { title: "登录", hidden: true, notNeedAuth: true }
    },
    {
      path: "/404",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),
      meta: { title: "404", hidden: true, notNeedAuth: true }
    },
    {
      path: "/",
      component: Layout,
      redirect: "/dashboard",
      children: [
        {
          path: "dashboard",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue"),
          name: "Dashboard",
          meta: {
            title: "工作台",
            icon: "dashboard",
            affix: true
          }
        },
        {
          path: "/statistics",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/statistics/index.vue"),
          meta: {
            title: "数据统计",
            icon: "icon-statistics"
          }
        },
        {
          path: "/competition/smallProgramManage",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/competition/smallProgramManageHandle.vue"),
          meta: {
            title: "小程序管理",
            hidden: true
          }
        },
        {
          path: "/smallProgramManage/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/competition/components/addSmallProgram.vue"),
          meta: {
            title: "新增小程序",
            hidden: true
          }
        },
        {
          path: "/competition/serviceManage",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/competition/serviceManageHandle.vue"),
          meta: {
            title: "客服管理",
            hidden: true
          }
        },
        {
          path: "/serviceManage/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/competition/components/addService.vue"),
          meta: {
            title: "新增客服",
            hidden: true
          }
        },
        {
          path: "competition",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/competition/index.vue"),
          meta: {
            title: "赛事管理",
            icon: "icon-category"
          }
        },{
          path: "/competition/two",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/competition/indexTwo.vue"),
          meta: {
            title: "赛事管理二级页面",
            hidden: true
          }
        },
        {
          path: "/competition/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addCompetition.vue"),
          meta: {
            title: "新建赛事",
            hidden: true
          }
        },
        {
          path: "/competition/titleManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/titleManage.vue"),
          meta: {
            title: "赛事管理",
            hidden: true
          }
        },
        {
          path: "/competition/noticeManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/noticeManage.vue"),
          meta: {
            title: "公告管理",
            hidden: true
          }
        },
        {
          path: "/notice/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addNotice.vue"),
          meta: {
            title: "新建公告",
            hidden: true
          }
        },
        {
          path: "/competition/promotionalImageManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/promotionalImageManage.vue"),
          meta: {
            title: "宣传图管理",
            hidden: true
          }
        },
        {
          path: "/promotionalImage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addPromotionalImage.vue"),
          meta: {
            title: "新建宣传图",
            hidden: true
          }
        },
        {
          path: "/competition/recordingPictureManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/recordingPictureManage.vue"),
          meta: {
            title: "轮播图管理",
            hidden: true
          }
        },
        {
          path: "/recordingPictureManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addRecordingPicture.vue"),
          meta: {
            title: "新建轮播图",
            hidden: true
          }
        },
        {
          path: "/competition/prizeDetailsManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/prizeDetailsManage.vue"),
          meta: {
            title: "奖品详情管理",
            hidden: true
          }
        },
        {
          path: "/prizeDetailsManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addPrizeDetails.vue"),
          meta: {
            title: "新建奖品详情",
            hidden: true
          }
        },
        {
          path: "/competition/eventRulesManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/eventRulesManage.vue"),
          meta: {
            title: "赛事规则管理",
            hidden: true
          }
        },
        {
          path: "/eventRulesManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addEventRules.vue"),
          meta: {
            title: "新建赛事规则",
            hidden: true
          }
        },
        {
          path: "/competition/eventIntroductionManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/eventIntroductionManage.vue"),
          meta: {
            title: "赛事介绍管理",
            hidden: true
          }
        },
        {
          path: "/eventIntroductionManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addEventIntroduction.vue"),
          meta: {
            title: "新建赛事介绍",
            hidden: true
          }
        },
        {
          path: "/competition/playerManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/playerManage.vue"),
          meta: {
            title: "选手管理",
            hidden: true
          }
        },
        {
          path: "/competition/hotManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/hotManage.vue"),
          meta: {
            title: "热度管理",
            hidden: true
          }
        },
        {
          path: "/competition/scoreManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/scoreManage.vue"),
          meta: {
            title: "参赛成员管理",
            hidden: true
          }
        },
        {
          path: "/competition/scoreRoundManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/scoreRoundManage.vue"),
          meta: {
            title: "赛事轮管理",
            hidden: true
          }
        },
        {
          path: "/competition/scoreRoundDetailManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/scoreRoundDetailManage.vue"),
          meta: {
            title: "成绩管理",
            hidden: true
          }
        },{
          path: "/competition/scoreContestantRoundDetailManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/scoreContestantRoundDetailManage.vue"),
          meta: {
            title: "选手成绩管理",
            hidden: true
          }
        },
        {
          path: "/scoreManage/import",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/importContestant.vue"),
          meta: {
            title: "参赛选手管理",
            hidden: true
          }
        },
        {
          path: "/scoreManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addContestant.vue"),
          meta: {
            title: "新增参赛选手",
            hidden: true
          }
        },
        {
          path: "/scoreRoundManage/addRound",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addRound.vue"),
          meta: {
            title: "新增赛事轮",
            hidden: true
          }
        },
        {
          path: "/scoreRoundManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addContestantRound.vue"),
          meta: {
            title: "新增参赛选手轮次",
            hidden: true
          }
        },
        {
          path: "/scoreRoundManage/import",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/importContestantRound.vue"),
          meta: {
            title: "导入参赛选手轮次",
            hidden: true
          }
        },
        {
          path: "/scoreRoundManage/setup",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/setUpRound.vue"),
          meta: {
            title: "设置标准杆",
            hidden: true
          }
        },
        {
          path: "/competition/votingRecordsManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/votingRecordsManage.vue"),
          meta: {
            title: "投票记录管理",
            hidden: true
          }
        },
        {
          path: "/playerManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addPlayer.vue"),
          meta: {
            title: "新增选手",
            hidden: true
          }
        },
        {
          path: "/playerManage/import",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/importPlayer.vue"),
          meta: {
            title: "导入选手",
            hidden: true
          }
        },
        {
          path: "/competition/openManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/openManage.vue"),
          meta: {
            title: "喔图管理",
            hidden: true
          }
        },
        {
          path: "/openManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addOpen.vue"),
          meta: {
            title: "新增喔图",
            hidden: true
          }
        },
        {
          path: "/competition/userOpenManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/userOpenManage.vue"),
          meta: {
            title: "开屏管理",
            hidden: true
          }
        },
        {
          path: "/userOpenManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addUserOpen.vue"),
          meta: {
            title: "新增开屏",
            hidden: true
          }
        },
        {
          path: "/competition/giftManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/giftManage.vue"),
          meta: {
            title: "礼物管理",
            hidden: true
          }
        },
        {
          path: "/giftManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addGift.vue"),
          meta: {
            title: "新建礼物",
            hidden: true
          }
        },
        {
          path: "/competition/liveStreamingManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/liveStreamingManage.vue"),
          meta: {
            title: "赛事直播管理",
            hidden: true
          }
        },
        {
          path: "/liveStreamingManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addLiveStreaming.vue"),
          meta: {
            title: "新建直播管理",
            hidden: true
          }
        },
        {
          path: "order",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/orderDetails/index.vue"),
          meta: {
            title: "订单管理",
            icon: "icon-order"
          }
        },
        // {
        //   path: "setmeal",
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ "@/views/setmeal/index.vue"),
        //   meta: {
        //     title: "套餐管理",
        //     icon: "icon-combo"
        //   }
        // },
        // {
        //   path: "dish",
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ "@/views/dish/index.vue"),
        //   meta: {
        //     title: "旅游信息管理",
        //     icon: "icon-dish"
        //   }
        // },
        {
          path: "/dish/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/dish/addDishtype.vue"),
          meta: {
            title: "添加菜品",
            hidden: true
          }
        },
        // {
        //   path: "commodity",
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ "@/views/commodity/index.vue"),
        //   meta: {
        //     title: "特产管理",
        //     icon: "icon-dish"
        //   }
        // },
        // {
        //   path: "test",
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ "@/views/A/index.vue"),
        //   meta: {
        //     title: "主键测试",
        //     icon: "icon-dish"
        //   }
        // },
        {
          path: "/commodity/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/commodity/addCommodity.vue"),
          meta: {
            title: "添加商品",
            hidden: true
          }
        },
        // {
        //   path: "limited",
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ "@/views/limited/index.vue"),
        //   meta: {
        //     title: "特产限时价管理",
        //     icon: "icon-dish"
        //   }
        // },
        {
          path: "category",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/category/index.vue"),
          meta: {
            title: "用户管理",
            icon: "icon-employee"
          }
        },
        {
          path: "employee",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/employee/index.vue"),
          meta: {
            title: "员工管理",
            icon: "icon-employee"
          }
        },
        {
          path: "/employee/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/employee/addEmployee.vue"),
          meta: {
            title: "添加员工",
            hidden: true
          }
        },
        {
          path: "/employee/empowerment",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/employee/empowerment.vue"),
          meta: {
            title: "赋权",
            hidden: true
          }
        },
        {
          path: "/employee/competitionEmployee",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/employee/competitionEmployee.vue"),
          meta: {
            title: "赛事员工关系管理",
            hidden: true
          }
        },
        {
          path: "/setmeal/add",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/setmeal/addSetmeal.vue"),
          meta: {
            title: "添加套餐",
            hidden: true
          }
        }
      ]
    },
    {
      path: "/other",
      component: Layout,
      redirect: "/competition",
      children: [
        // {
        //   path: "dashboard",
        //   component: () =>
        //     import(/* webpackChunkName: "dashboard" */ "@/views/dashboard/index.vue"),
        //   name: "Dashboard",
        //   meta: {
        //     title: "工作台",
        //     icon: "dashboard",
        //     affix: true
        //   }
        // },
        // {
        //   path: "/statistics",
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ "@/views/statistics/index.vue"),
        //   meta: {
        //     title: "数据统计",
        //     icon: "icon-statistics"
        //   }
        // },
        {
          path: "competition",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/competition/index.vue"),
          meta: {
            title: "赛事管理",
            icon: "icon-category"
          }
        },
        {
          path: "/competition/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addCompetition.vue"),
          meta: {
            title: "新建赛事",
            hidden: true
          }
        },
        {
          path: "/competition/titleManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/titleManage.vue"),
          meta: {
            title: "赛事管理",
            hidden: true
          }
        },
        {
          path: "/competition/noticeManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/noticeManage.vue"),
          meta: {
            title: "公告管理",
            hidden: true
          }
        },
        {
          path: "/notice/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addNotice.vue"),
          meta: {
            title: "新建公告",
            hidden: true
          }
        },
        {
          path: "/competition/promotionalImageManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/promotionalImageManage.vue"),
          meta: {
            title: "宣传图管理",
            hidden: true
          }
        },
        {
          path: "/promotionalImage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addPromotionalImage.vue"),
          meta: {
            title: "新建宣传图",
            hidden: true
          }
        },
        {
          path: "/competition/recordingPictureManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/recordingPictureManage.vue"),
          meta: {
            title: "轮播图管理",
            hidden: true
          }
        },
        {
          path: "/recordingPictureManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addRecordingPicture.vue"),
          meta: {
            title: "新建轮播图",
            hidden: true
          }
        },
        {
          path: "/competition/prizeDetailsManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/prizeDetailsManage.vue"),
          meta: {
            title: "奖品详情管理",
            hidden: true
          }
        },
        {
          path: "/prizeDetailsManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addPrizeDetails.vue"),
          meta: {
            title: "新建奖品详情",
            hidden: true
          }
        },
        {
          path: "/competition/eventRulesManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/eventRulesManage.vue"),
          meta: {
            title: "赛事规则管理",
            hidden: true
          }
        },
        {
          path: "/eventRulesManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addEventRules.vue"),
          meta: {
            title: "新建赛事规则",
            hidden: true
          }
        },
        {
          path: "/eventRulesManage/addOne",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addEventRulesOne.vue"),
          meta: {
            title: "新建赛事规则",
            hidden: true
          }
        },
        {
          path: "/competition/eventIntroductionManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/eventIntroductionManage.vue"),
          meta: {
            title: "赛事介绍管理",
            hidden: true
          }
        },
        {
          path: "/eventIntroductionManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addEventIntroduction.vue"),
          meta: {
            title: "新建赛事介绍",
            hidden: true
          }
        },
        {
          path: "/eventIntroductionManage/update",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/updateEventIntroduce.vue"),
          meta: {
            title: "修改赛事介绍",
            hidden: true
          }
        },
        {
          path: "/competition/playerManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/playerManage.vue"),
          meta: {
            title: "选手管理",
            hidden: true
          }
        },
        {
          path: "/playerManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addPlayer.vue"),
          meta: {
            title: "新增选手",
            hidden: true
          }
        },
        {
          path: "/playerManage/import",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/importPlayer.vue"),
          meta: {
            title: "导入选手",
            hidden: true
          }
        },
        {
          path: "/competition/giftManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/giftManage.vue"),
          meta: {
            title: "礼物管理",
            hidden: true
          }
        },
        {
          path: "/giftManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addGift.vue"),
          meta: {
            title: "新建礼物",
            hidden: true
          }
        },
        {
          path: "/competition/liveStreamingManage",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/liveStreamingManage.vue"),
          meta: {
            title: "赛事直播管理",
            hidden: true
          }
        },
        {
          path: "/liveStreamingManage/add",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/competition/components/addLiveStreaming.vue"),
          meta: {
            title: "新建直播管理",
            hidden: true
          }
        },
        {
          path: "order",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/orderDetails/index.vue"),
          meta: {
            title: "订单管理",
            icon: "icon-order"
          }
        },
        // {
        //   path: "category",
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ "@/views/category/index.vue"),
        //   meta: {
        //     title: "用户管理",
        //     icon: "icon-employee"
        //   }
        // },
        // {
        //   path: "employee",
        //   component: () =>
        //     import(/* webpackChunkName: "shopTable" */ "@/views/employee/index.vue"),
        //   meta: {
        //     title: "员工管理",
        //     icon: "icon-employee"
        //   }
        // },
        // {
        //   path: "/employee/add",
        //   component: () =>
        //     import(/* webpackChunkName: "dashboard" */ "@/views/employee/addEmployee.vue"),
        //   meta: {
        //     title: "添加员工",
        //     hidden: true
        //   }
        // },
      ]
    },
    {
      path: "/phone",
      component: Layout,
      redirect: "/playerManage",
      children: [
        {
          path: "/playerManage",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/phone/playerManage.vue"),
          meta: {
            title: "选手管理",
            icon: "icon-category"
          }
        },
        {
          path: "/hotManage",
          component: () =>
            import(/* webpackChunkName: "shopTable" */ "@/views/phone/hotManage.vue"),
          meta: {
            title: "热度管理",
            icon: "icon-category"
          }
        },
        {
          path: "/playerManage/added",
          component: () =>
            import(/* webpackChunkName: "dashboard" */ "@/views/phone/components/addPlayer.vue"),
          meta: {
            title: "新增选手",
            hidden: true
          }
        },
      ]
    },
    {
      path: "*",
      redirect: "/404",
      meta: { hidden: true }
    }
  ]
});

export default router;
